import { convertBytes } from '@nx-frontend/shared/utils';

interface ListItemSizeProps {
  size: number;
}

export const ListItemSize: React.FC<ListItemSizeProps> = ({ size }) => {
  const convertedSize = convertBytes(size);
  return <p>{convertedSize}</p>;
};
